import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b38e772"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-row" }
const _hoisted_2 = { class: "action-buttons" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { TorneoPropioDTO } from "@/interfaces/Torneo";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import {
  VDataTable,
  VCard,
  VCardTitle,
  VDivider,
  VTextField,
} from "vuetify/components";
import { useAuth } from "@/composables/useAuth";
import {
  getTorneosCreadosUsuario,
  deleteTorneo,
} from "@/services/TorneosService";


export default /*#__PURE__*/_defineComponent({
  __name: 'TablaTorneosCreados',
  setup(__props) {

const { getidUsuario } = useAuth();
const idUsuarioLogger = ref<string | null>(getidUsuario.value);

const search = ref<string>("");
const items = ref<TorneoPropioDTO[]>([]);
const isLoading = ref<boolean>(true);

const router = useRouter();
const showSuccessBorrarModal = ref<boolean>(false);
const showErrorBorrarModal = ref<boolean>(false);

const headers = [{ title: "NOMBRE", key: "nombreTorneo" }];

const viewDetails = (idTorneo: number) => {
  router.push({ name: "detalle-torneo-gestion", params: { idTorneo } });
};

const viewDetailsTorneoEquipos = (idTorneo: number) => {
  router.push({ name: "detalle-torneo-gestion-equipos", params: { idTorneo } });
};

const viewDetailsTorneoIndividualMasDeUnaLista = (idTorneo: number) => {
  router.push({
    name: "detalle-torneo-gestion-individual-mas",
    params: { idTorneo },
  });
};

const deleteTournament = async (idTorneo: number) => {
  try {
    await deleteTorneo(idTorneo);
    items.value = items.value.filter((item) => item.idTorneo !== idTorneo);
    showSuccessBorrarModal.value = true;
  } catch (error) {
    console.error("Error deleting tournament:", error);
    showErrorBorrarModal.value = true;
  }
};

onMounted(async () => {
  try {
    isLoading.value = true;
    if (idUsuarioLogger.value != null) {
      const responseTorneosCreados = await getTorneosCreadosUsuario(
        idUsuarioLogger.value
      );
      items.value = responseTorneosCreados.data;
    }
  } catch (error) {
    console.error("Error recuperando torneos creados por el usuario:", error);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(VCard), { flat: "" }, {
      default: _withCtx(() => [
        _createVNode(_unref(VCardTitle), { class: "d-flex align-center pe-2" }, {
          default: _withCtx(() => [
            _createTextVNode("Torneos propios "),
            _createVNode(_component_v_spacer),
            _createVNode(_unref(VTextField), {
              modelValue: search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              density: "compact",
              label: "Buscar",
              "prepend-inner-icon": "mdi-magnify",
              variant: "solo-filled",
              flat: "",
              "hide-details": "",
              "single-line": "",
              class: "search-field"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(VDivider)),
        _createVNode(_unref(VDataTable), {
          search: search.value,
          "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
          items: items.value,
          loading: isLoading.value,
          headers: headers,
          class: "custom-table",
          "item-key": "idTorneo"
        }, {
          item: _withCtx(({ item }) => [
            _createElementVNode("tr", _hoisted_1, [
              _createElementVNode("td", null, _toDisplayString(item.nombreTorneo), 1),
              _createElementVNode("td", _hoisted_2, [
                (item.tipoTorneo != 'Individual')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_v_btn, {
                        onClick: ($event: any) => (viewDetailsTorneoEquipos(item.idTorneo)),
                        icon: "mdi-eye",
                        color: "primary",
                        elevation: "2",
                        variant: "tonal"
                      }, null, 8, ["onClick"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (
                  item.tipoTorneo == 'Individual' && item.listasPorJugador > 1
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_v_btn, {
                              onClick: ($event: any) => (
                    viewDetailsTorneoIndividualMasDeUnaLista(item.idTorneo)
                  ),
                              icon: "mdi-eye",
                              color: "primary",
                              elevation: "2",
                              variant: "tonal"
                            }, null, 8, ["onClick"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_v_btn, {
                              onClick: ($event: any) => (viewDetails(item.idTorneo)),
                              icon: "mdi-eye",
                              color: "primary",
                              elevation: "2",
                              variant: "tonal"
                            }, null, 8, ["onClick"])
                          ]))
                    ])),
                _createVNode(_component_v_btn, {
                  onClick: ($event: any) => (deleteTournament(item.idTorneo)),
                  color: "error",
                  icon: "mdi-close",
                  elevation: "2",
                  variant: "tonal"
                }, null, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["search", "items", "loading"])
      ]),
      _: 1
    }),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessBorrarModal.value,
      message: "Torneo borrado con éxito.",
      "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showSuccessBorrarModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorBorrarModal.value,
      message: "No se ha podido borrar el torneo. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showErrorBorrarModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})